export default "__VITE_ASSET__831C4zF5__"